export const AI_FEATURE = {
  has_ai_summarisation: {
    name: "Summarisation",
  },
  has_ai_keyword_suggestion: {
    name: "Keyword Suggestion",
  },
  has_ai_general_assistant: {
    name: "General Assistant",
  },
  has_ai_boolean_creator: {
    name: "Boolean Creator",
  },
  has_ai_mention_streams_creator: {
    name: "Mention Stream Creator",
  },
} as const;

export const AI_PROVIDER = {
  google_vertex_ai: {
    name: "Google Vertex AI",
  },
} as const;

export const AI_PROVIDER_MODEL = {
  "gemini-1.5-pro-002": {
    name: "Gemini 1.5 Pro 002",
    provider: "google_vertex_ai",
  },
  "gemini-2.0-flash-001": {
    name: "Gemini 2.0 Flash 001",
    provider: "google_vertex_ai",
  },
  "gemini-2.0-flash-lite-001": {
    name: "Gemini 2.0 Flash Lite 001",
    provider: "google_vertex_ai",
  },
  "gemini-2.5-pro-preview-05-06": {
    name: "Gemini 2.5 Pro Preview 05-06",
    provider: "google_vertex_ai",
  },
  "gemini-2.5-flash-preview-05-20": {
    name: "Gemini 2.5 Flash Preview 05-20",
    provider: "google_vertex_ai",
  },
} as const;

export const AI_AGENT = {
  test_agent_please_ignore: {
    name: "Test Agent Please Ignore",
  },
  mention_stream_builder: {
    name: "Mention Stream Builder",
  },
  mention_stream_creator_response: {
    name: "Mention Stream Creator Response",
  },
};
